import { GraphQlClient } from "@contember/client";
import { useMemo } from "react";
import { useApiBaseUrl } from "./config/useApiBaseUrl.js";
import { useSessionToken } from "./auth/useSessionToken.js";
const useGraphQlClient = (path) => {
  const apiBaseUrl = useApiBaseUrl();
  const sessionToken = useSessionToken();
  return useMemo(() => new GraphQlClient(`${apiBaseUrl}${path}`, sessionToken), [apiBaseUrl, path, sessionToken]);
};
export {
  useGraphQlClient
};
//# sourceMappingURL=useGraphQlClient.js.map
